import { CaasContentsResponse, CMSBrandLogo } from '../types/cms'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// CoreMedia 12 (CaaS) CMS endpoint, alternative to the legacy CAE
// (CaeApi); the switch between the two lives in CmsApi.
// CMDownload items expose the file URL in data.uri and the brand code
// in subjectTaxonomy[].externalReference. contextFree=true is
// required: without it nothing is found.
const mapCaasContentsToLogos = (
	response: CaasContentsResponse,
): CMSBrandLogo[] => {
	const result = response?.contents?.result || []

	return result.map(item => ({
		code:
			item.subjectTaxonomy?.find(
				({ externalReference }) => externalReference !== 'logo',
			)?.externalReference || '-1',
		urlBrandLogo: item.data?.uri || null,
	}))
}

export const CaasApi = createApi({
	reducerPath: 'CmsApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_API_CMS_CAAS_URL}` || '',
	}),
	endpoints: build => ({
		getBrandsLogo: build.query<CMSBrandLogo[], void>({
			query: () =>
				'/contents-contenthub-cross/contenthub-en-us/?docTypes=CMDownload&tagNames=logo&contextFree=true',
			transformResponse: mapCaasContentsToLogos,
		}),
	}),
})

export const { useGetBrandsLogoQuery: useGetBrandsLogoCaasQuery } = CaasApi
